export const seloDaParticipacao = {
  ASSINOU: { rotulo: 'Assinou', variante: 'success' },
  NA_VEZ: { rotulo: 'Na vez', variante: 'brand' },
  AGUARDANDO: { rotulo: 'Aguardando', variante: 'neutral' },
  A_CONFERIR: { rotulo: 'A conferir', variante: 'warning' },
} as const;

export const rotuloFalhaNoEnvio = 'Falha no envio';
